export let redirectAfterLogout = () => {
  window.location.href = '/'
}

try {
  redirectAfterLogout = require(`./../apps/${process.env.APP_NAME}/src/utils/redirectAfterLogout.tsx`).default
} catch (error) {}

export default  redirectAfterLogout